import { render } from "./InstanceCard.vue?vue&type=template&id=3d6dd59d&scoped=true"
import script from "./InstanceCard.vue?vue&type=script&lang=js"
export * from "./InstanceCard.vue?vue&type=script&lang=js"

import "./InstanceCard.vue?vue&type=style&index=0&id=3d6dd59d&scoped=true&lang=css"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6dd59d"]])

export default __exports__